import { UserFacingError } from './errors'

export class SubscriptionInactiveError extends UserFacingError {
  readonly orgId?: string
  readonly orgType?: string

  constructor(message?: string, options: { orgId?: string; orgType?: string } = {}) {
    super(message ?? 'Subscription required to access this feature.')
    this.name = 'SubscriptionInactiveError'
    this.orgId = options.orgId
    this.orgType = options.orgType
  }
}
